export const environment = {
  name: 'staging',
  production: false,
  baseUrlMuvStok: 'https://stage.api.muvstok.com.br',
  urlMovidesk: 'https://muvstok.movidesk.com/',
  identityURL: 'https://stage.serviceshub.com.br',
  realm: 'muvstok-staging',
  clientId: 'muvstok',
};
